/* eslint-disable import/extensions */
/* eslint-disable react/forbid-prop-types */
import React, { useContext, useMemo } from 'react'
import SIM from '@apps/components/SIM'
import SIMCardNumber from '@apps/components/SIMCardNumber'
import PropTypes from 'prop-types'
import { useSelector } from 'react-redux'
import { Typography } from '@telus/koodo-ui-kit'
import { APPLICATION_STATE, ApplicationContext } from '@apps/contexts/ApplicationContext'
import {
  getSimSelectionPageContent,
  getSimSelectionSlugValue
} from '@apps/utils/simSelectionContent'

const SIM_CARD_NUMBER_HEADING_TOKENS = {
  color: '#000000',
  fontName: 'StagSans',
  fontSize: 20,
  fontWeight: 700,
  letterSpacing: 0,
  lineHeight: '28px'
}

const HaveSimCardDetail = ({ userType, simRef }) => {
  const { pageContent } = useSelector((state) => state.common.content)
  const { [APPLICATION_STATE.CURRENT_LANGUAGE]: language } = useContext(ApplicationContext)

  const simSelectionPageContent = getSimSelectionPageContent(pageContent, language, userType)
  const { shortTextFields } = simSelectionPageContent

  const textContent = useMemo(() => {
    if (!shortTextFields) return {}
    return {
      simCardNumberHeading:
        getSimSelectionSlugValue(shortTextFields, 'simCardNumberHeading', userType)
    }
  }, [shortTextFields, userType])

  return (
    <div>
      {textContent?.simCardNumberHeading && (
        <div
          className="mb-4"
          data-contentful-slug="simCardNumberHeading"
        >
          <Typography
            variant={{ size: 20, bold: true, color: '#000000' }}
            tokens={SIM_CARD_NUMBER_HEADING_TOKENS}
          >
            {textContent?.simCardNumberHeading}
          </Typography>
        </div>
      )}
      <SIMCardNumber className="mb-6" userType={userType} />
      <SIM simRef={simRef} userType={userType} showHeading={false} />
    </div>
  )
}

HaveSimCardDetail.propTypes = {
  userType: PropTypes.string.isRequired,
  simRef: PropTypes.object.isRequired
}

export default HaveSimCardDetail
